import {
  HttpClient,
  HttpErrorResponse
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import {
  Observable,
  throwError
} from "rxjs";
import {
  catchError, map, tap,
} from "rxjs/operators";
import { ApiEndpointService } from "./api-endpoint.service";
import { AuthService } from "./auth.service";
import { GlobalService } from "./global.service";
import * as GlobalActions from "../state/global/global.action";
import * as PartnerBrandingActions from "../state/partner-branding/partner-branding.action";

import { ToastAlertService } from "src/app/shared/utils/toast.service";
import { StorageService } from "src/app/shared/utils/storage.service";
import { retryTransientHttp } from "src/app/shared/utils/http-retry.util";

@Injectable({
  providedIn: "root"
})
export class TenantService {

  constructor(private http: HttpClient, private toastService: ToastAlertService,
    private globalService: GlobalService,
    private authService: AuthService,
    private storageService: StorageService,
    private store: Store) { }



  public getTenantDetails(): Observable<any> {
    const url = ApiEndpointService.getEndpoint(ApiEndpointService.ENDPOINT.VERIFY_TENANT) + location.hostname;
    return this.http.get(url).pipe(
      /* SAN-1672 / SC-SAAS-FRONTEND-26 -- this is the app's bootstrap call and any error here
         is fatal for the visitor (AppComponent shows the "Direct access is not allowed" state and
         raises a fatal Sentry event). The tenants API answers with 0 / 504 in bursts under load
         and the same request succeeds moments later, so retry a transient gateway/network fault
         twice (about 1.5 s, then 3 s) before giving up. Any other error is passed straight through,
         unchanged. Placed before tap() so the dispatches only ever run on the successful attempt. */
      retryTransientHttp(2, 1500),
      tap((res: any) => {
        console.log('getPartnerDetails==>', res)
        if(res?.data) {
          // SAN-219 — must run before SetBrandDetails is dispatched, not
          // after. getBrandDetails() going truthy is the app-wide signal
          // that it's safe to call the tenant's business API (see
          // AppComponent's own GetProfileTypes dispatch, gated on it), but
          // ApiEndpointService.DOMAIN still pointed at the cockpit's default
          // base URL until whichever subscriber called setApiEndPoint()
          // finished running - previously only AppComponent's own
          // .subscribe() callback, which necessarily runs AFTER this tap().
          // Any other consumer reacting to the store update in between (no
          // guaranteed ordering across subscribers) could fire a business
          // call before the endpoint was repointed, hitting the cockpit host
          // and 404ing (SC-SAAS-FRONTEND-H/2J). Setting it here, before the
          // dispatch, means DOMAIN is always correct by the time anything
          // observes brand details as available.
          if (res.data.apiUrl) {
            ApiEndpointService.setApiEndPoint(res.data.apiUrl);
          }
          this.store.dispatch(new GlobalActions.SetBrandDetails(res?.data))
          this.storageService.setObject(StorageService.storageKeys.brandDetails, res?.data)
          // SAN-384/386 — the cockpit's `resolve-domain/:hostname` adds one
          // optional field over `verify_tenant`: `partnerAbbreviation`, set only
          // when this hostname is a partner (spoke) subdomain. Carried into its
          // own state slice; `null` on every hub hostname, which is exactly
          // today's behavior.
          this.store.dispatch(new PartnerBrandingActions.SetPartnerAbbreviation(res?.data?.partnerAbbreviation || null))
        }
      }),
      catchError((fault: HttpErrorResponse) => {
        // this.toastService.showToast(this.globalService.getErrorMessage(fault, 'Error while uploading logo!'), 'error');
        // console.warn(`save inverstor Uplogo( ${fault?.error?.message} )`);
        return throwError(() => fault);
      })
    );
  }


}
